<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    if (this._isMobile()) {
      //移动端
      this.$router.push('/introduce_wap');
    } else {
      //PC端
      this.$router.push('/introduce_pc');
    }
  },
  methods: {
    _isMobile() {      
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)      
      return flag;    
    }
  }
}
</script>

<style>
  /* 清除默认样式 */
  *{
    margin: 0;
    padding: 0;
  }
  li{
    list-style:none;
  }
  img{
    vertical-align:top;
    border:none;
  }
  /* 设置字体基数 */
  #app {
    font-size: 20px;
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue